<!--Checkbox Options-->
@if (mode === 'qcm') {
  <div class="checkbox-group"
    [ngClass]="{showFinalAnswers: showFinalAnswers, answersChecked: testAnswer}">
    @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; track option) {
      <mat-checkbox
        [ngClass]="optionState(option)"
        (change)="informThatUserInteracted($event)"
        [disableRipple]="true"
        [disabled]="showFinalAnswers || testAnswer || validated || lessonsService.isAtLeastTrainerAndAssignmentExist || disabled"
        [(ngModel)]="option.select ">
        <span [innerHTML]="option.answer | stringToHtml"></span>
      </mat-checkbox>
    }
  </div>
}

<!--Radio Options-->
@if (mode === 'qcu') {
  <mat-radio-group [ngClass]="{showFinalAnswers: showFinalAnswers, answersChecked: testAnswer}"  [(ngModel)]="valueChecked">
    @for (option of availableAnswers | intToBoolean: 'correct_answer':'select'; track option) {
      <mat-radio-button
        (change)="radioChange($event.value)"
        [disabled]="showFinalAnswers || testAnswer || validated || lessonsService.isAtLeastTrainerAndAssignmentExist || disabled"
        [ngClass]="optionState(option)"
        [disableRipple]="true" [value]="option.answer">
        <span [innerHTML]="option.answer | stringToHtml"></span>
      </mat-radio-button>
    }
  </mat-radio-group>
}